export default __webpack_public_path__ + "static/media/thank-you.55a8c05c.png";